import { defaultAction } from "./defaultAction";
import {
  FILL_INVENTORY_THUNK_RUNNING,
  FILL_INVENTORY
} from "@constants/actionTypes";
import { sendBugsnagError } from "@utils/Bugsnag";

export const clearInventory = () => async (dispatch, getState, api) => {
  dispatch(defaultAction(FILL_INVENTORY, { inventory: [] }));
};

export const getMerchInventory =
  (id, fillAction) => async (dispatch, getState, api) => {
    dispatch(defaultAction(FILL_INVENTORY_THUNK_RUNNING));
    try {
      const inventory = await api.get(`v3/merchants/${id}/inventory`);
      dispatch(defaultAction(fillAction, inventory.data));
    } catch (error) {
      sendBugsnagError(error, "actions/getMerchInventory");
      dispatch(defaultAction(fillAction, { inventory: [] }));
    }
  };
